import { render } from "./SuccesfullPasswordRecovery.vue?vue&type=template&id=29eb555b&scoped=true"
import script from "./SuccesfullPasswordRecovery.vue?vue&type=script&lang=js"
export * from "./SuccesfullPasswordRecovery.vue?vue&type=script&lang=js"

import "./SuccesfullPasswordRecovery.vue?vue&type=style&index=0&id=29eb555b&scoped=true&lang=css"

import exportComponent from "/home/learnbil/public_html/learnbilly.com/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29eb555b"]])

export default __exports__